module.exports = __webpack_public_path__ + "static/media/mypic.b8b7ea33.png";